// Dependencies
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

// Components
import OrderDetail from '../OrderDetail';
import Checkout from '../Checkout';
import Ticket from '../Ticket';
import OrderHeader from '../OrderHeader';
import LastFooter from '../LastFooter';
import Payment from '../Payment';
import CountDown from '../CountDown';

// Styles
import styles from './index.module.sass';

export default function Order({
  history,
  match,
  getCookie,
  webservice,
  device,
  setSessionMessage,
  screenSize,
}) {
  const { t } = useTranslation('order');

  function handleClose() {
    history.push('/cart');
  }

  // For count down
  const initial_date = new Date('November 04, 2026 02:00:00').getTime();
  const target_date = new Date('November 09, 2026 23:59:59').getTime();

  const today = new Date().getTime();
  const [showCount, setShowCount] = useState(target_date > today && today > initial_date);

  return (
    <div className={`${styles.order} ${styles[screenSize]}`}>
      {showCount && (
        <div className={styles.countDownContainer}>
          {
            <CountDown
              target_date={target_date}
              showCount={showCount}
              setShowCount={setShowCount}
              screenSize={screenSize}
            />
          }
        </div>
      )}
      <OrderHeader />

      <div className={styles.orderHeader}>
        <div className={styles.return} onClick={handleClose}>
          <i className='material-icons-outlined'>navigate_before</i>
          <span className={styles.returnText}>{t('return')}</span>
        </div>
      </div>

      <Switch>
        <Route
          path={`${match.path}/checkout/:hostedTransactionIdentifier`}
          render={(props) => {
            return (
              <Checkout
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/payment/:irelandPayTransactionToken`}
          render={(props) => {
            return (
              <Payment
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/ticket/:irelandPayTransactionToken?`}
          render={(props) => {
            return (
              <Ticket
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          exact
          path={`${match.path}/:orderMessage?`}
          render={(props) => {
            return (
              <OrderDetail
                history={history}
                match={match}
                getCookie={getCookie}
                webservice={webservice}
                device={device}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
      </Switch>
      <LastFooter screenSize={screenSize} />
    </div>
  );
}
